import { render, staticRenderFns } from "./TheWelcome.vue?vue&type=template&id=27cba34d&lang=pug&"
import script from "./TheWelcome.vue?vue&type=script&lang=js&"
export * from "./TheWelcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports